import { Icon, Home, BookOpen, Mail, Tool } from "react-feather";
import AppNavSection from "./AppNavSection";
import React from "react";
import AppNavLink from "./AppNavLink";
import { List } from "@material-ui/core";
import { matchPath } from "react-router-dom";

export interface AppLink {
  title: string;
  href: string;
  childLinks?: AppLink[];
  icon?: Icon;
}

export enum AppLinkHrefs {
  Home = "/",
  Book = "/book",
  Introduction = "/book/introduction",
  Chapter1 = "/book/chapter1",
  Chapter2 = "/book/chapter2",
  Chapter3 = "/book/chapter3",
  Terms = "/policy/terms",
  Subscribe = "/subscribe",
  Resources = "/resources",
  Gumroad = "/gumroad",
}

export const AppLinks: AppLink[] = [
  {
    title: "Home",
    icon: Home,
    href: AppLinkHrefs.Home,
  },
  {
    title: "Book",
    icon: BookOpen,
    href: AppLinkHrefs.Book,
    childLinks: [
      {
        title: "Introduction",
        href: AppLinkHrefs.Introduction,
      },
      {
        title: "Chapter 1",
        href: AppLinkHrefs.Chapter1,
      },
      {
        title: "Chapter 2",
        href: AppLinkHrefs.Chapter2,
      },
      {
        title: "Chapter 3",
        href: AppLinkHrefs.Chapter3,
      },
    ],
  },
  {
    title: "Resources",
    icon: Tool,
    href: AppLinkHrefs.Resources,
  },
  {
    title: "Subscribe",
    icon: Mail,
    href: AppLinkHrefs.Subscribe,
  },
];

export function renderNavLinks(path: string) {
  const renderLink = (appLink: AppLink, root: boolean) =>
    appLink.childLinks ? (
      <AppNavSection
        key={appLink.title}
        title={appLink.title}
        icon={appLink.icon}
        isOpen={
          !!matchPath(path, {
            path: appLink.href,
            exact: false,
          })
        }
      >
        {appLink.childLinks.map((childLink) => renderLink(childLink, false))}
      </AppNavSection>
    ) : (
      <AppNavLink
        key={appLink.title}
        root={root}
        title={appLink.title}
        icon={appLink.icon}
        href={appLink.href}
      />
    );

  return (
    <List disablePadding>{AppLinks.map((link) => renderLink(link, true))}</List>
  );
}
